import axios from 'axios';
import { getAuthHeaders } from '../utils/apiUtils';
import { BillingPrice, BillingPricingDetails } from '../models';

const host = process.env.REACT_APP_ApiUrl || '';

export const getBillingPricingDetails = async (businessModule: string): Promise<BillingPricingDetails> => {
  let params = '?channel=SHOPIFY';
  if (!businessModule) { // for backward compatibility
    params = params + `&billingCycle=ANNUALLY&businessModules=${process.env.REACT_APP_MODULE_ID}`;
  } else if (businessModule.toLocaleLowerCase() == 'flex') {
    params = params + `&billingCycle=MONTHLY&businessModuleKeys=${businessModule}`;
  } else if (businessModule.toLocaleLowerCase() == 'standard') {
    params = params + `&billingCycle=ANNUALLY&businessModuleKeys=${businessModule}`;
  }
  const url = `${host}/v1/private/business-upgrades/pricing/calculate${params}`;

  try {
    const rawResult = await axios.get(url, { headers: getAuthHeaders() });
    return getParsedBillingPricingResult(rawResult);
  } catch (e) {
    console.log(`Failed to retrieve billing pricing details. Url: ${url} Reason: ${e.message}`);
    throw e;
  }
};

const getParsedBillingPricingResult = (rawResult: any): BillingPricingDetails => {
  const {
    billingCycle, monthlyPrice, contractPrice, billingCyclePrice, businessModules,
  } = rawResult.data.prices[0]; // TODO should we use the data object as price instead of price[0]?

  const { prices, defaultPrice, ...rawPrice } = rawResult.data;

  return {
    businessModules: businessModules,
    rawPrice: rawPrice,
    billingCycle,
    rawMonthlyPrice: monthlyPrice,
    rawContractPrice: contractPrice,
    rawBillingCyclePrice: billingCyclePrice,
    monthlyPrice: mapRawBillingPriceToBillingPrice(monthlyPrice),
    contractPrice: mapRawBillingPriceToBillingPrice(contractPrice),
    billingCyclePrice: mapRawBillingPriceToBillingPrice(billingCyclePrice),
  };
};

const mapRawBillingPriceToBillingPrice = (billingPrice: any): BillingPrice => {
  const { price, totalPrice } = billingPrice;
  return {
    price: {
      amount: price.amount,
      formattedAmount: price.formattedAmount,
    },
    totalPrice: {
      amount: totalPrice.amount,
      formattedAmount: totalPrice.formattedAmount,
    },
  };
};
